// utils/formatUtcToString.js
export const formatUtcToString = (date = new Date()) => {
  try {
    const pad = (n) => n.toString().padStart(2, '0')

    // pastiin date valid
    const d = new Date(date)
    if (isNaN(d)) throw new Error('Invalid date')

    const year = d.getFullYear()
    const month = pad(d.getMonth() + 1)
    const day = pad(d.getDate())
    const hours = pad(d.getHours())
    const minutes = pad(d.getMinutes())
    const seconds = pad(d.getSeconds())

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  } catch (err) {
    console.warn('formatUtcToString error:', err)
    return null
  }
}
